import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logo from "../../images/logo.png";
import Services from "../../api/Services";
import Img1 from "../../images/instragram/1.jpg";
import Img2 from "../../images/instragram/2.jpg";
import Img3 from "../../images/instragram/3.jpg";
import Img4 from "../../images/instragram/4.jpg";
import Img5 from "../../images/instragram/5.jpg";
import Img6 from "../../images/instragram/6.jpg";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const Footer = (props) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const validateEmail = (value) => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(String(value).toLowerCase());
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateEmail(email)) {
      setError("");
    } else {
      setError(t("subscribe.errors.emailInvalid"));
    }
  };

  const {
    upperContactArea = false,
    InstagramShow = false,
    NewsletterShow = true,
    FooterShape = true,
  } = props;

  return (
    <footer className={"" + props.hclass}>
      {upperContactArea && (
        <div className="upper-contact-area">
          <div className="container">
            <div className="row">
              <div className="col col-xs-12">
                <div className="contact-grids">
                  <div className="grid">
                    <div className="icon">
                      <i className="fi flaticon-location-1"></i>
                    </div>
                    <div className="details">
                      <h5>{t("footer.location")}:</h5>
                      <p>{t("contactPage.address")}</p>
                    </div>
                  </div>
                  <div className="grid">
                    <div className="icon">
                      <i className="fi flaticon-email"></i>
                    </div>
                    <div className="details">
                      <h5>{t("footer.email")}:</h5>
                      <p>olamiroh@mail.ru</p>
                    </div>
                  </div>
                  <div className="grid">
                    <div className="icon">
                      <i className="fi flaticon-phone-call"></i>
                    </div>
                    <div className="details">
                      <h5>{t("footer.phone")}:</h5>
                      <p>+992928808292</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="upper-footer">
        <div className="container">
          <div className="row">
            <div className="col col-lg-4 col-md-6 col-12">
              <div className="widget about-widget">
                <div className="logo widget-title">
                  <img src={logo} alt="" />
                </div>
                <p>{t("footer.aboutText")}</p>
              </div>
            </div>
            <div className="col col-lg-2 col-md-6 col-12">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>{t("footer.navigation")}</h3>
                </div>
                <ul>
                  <li>
                    <Link onClick={ClickHandler} to="/about">
                      {t("nav.about")}
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/contact">
                      {t("nav.contact")}
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/service">
                      {t("nav.services")}
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/project">
                      {t("nav.projects")}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col col-lg-3 col-md-6 col-12">
              <div className="widget link-widget service-link-widget">
                <div className="widget-title">
                  <h3>{t("footer.allServices")}</h3>
                </div>
                <ul>
                  {Services.slice(0, 4).map((fservic, index) => (
                    <li key={index}>
                      <Link to="/home">{fservic.title}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            {NewsletterShow && (
              <div className="col col-lg-3 col-md-6 col-12">
                <div className="widget newsletter-widget">
                  <div className="widget-title">
                    <h3>{t("footer.news")}</h3>
                  </div>
                  <p>{t("footer.newsText")}</p>
                  <form onSubmit={handleSubmit}>
                    <div className="input-1">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email Address *"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    {error && (
                      <div className="error-message" style={{ color: "red" }}>
                        {error}
                      </div>
                    )}
                    <div className="submit clearfix">
                      <button type="submit">
                        <i className="ti-email"></i>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}
            {InstagramShow && (
              <div className="col col-lg-3 col-md-6 col-12">
                <div className="widget instagram">
                  <div className="widget-title">
                    <h3>{t("footer.gallery")}</h3>
                  </div>
                  <ul className="d-flex">
                    <li>
                      <img src={Img1} alt="" />
                    </li>
                    <li>
                      <img src={Img2} alt="" />
                    </li>
                    <li>
                      <img src={Img3} alt="" />
                    </li>
                    <li>
                      <img src={Img4} alt="" />
                    </li>
                    <li>
                      <img src={Img5} alt="" />
                    </li>
                    <li>
                      <img src={Img6} alt="" />
                    </li>
                  </ul>
                </div>
              </div>
            )}
          </div>
        </div>
        {FooterShape && (
          <div>
            <div className="vector-1"></div>
            <div className="vector-2"></div>
            <div className="vector-3"></div>
            <div className="vector-4"></div>
            <div className="vector-5"></div>
            <div className="vector-6"></div>
            <div className="vector-7"></div>
            <div className="vector-8"></div>
          </div>
        )}
      </div>
      <div className="wpo-lower-footer">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12 col-12">
              <p className="copyright">
                {t("footer.copyright")} &copy;<span>2026</span>
                <span className="copyright-icon">|</span> {t("footer.rights")}
              </p>
            </div>
            <div className="col-lg-6 col-md-12 col-12"></div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
